export default __webpack_public_path__ + "static/media/suggested-vat-20.db3a7196.png";